import gql from "graphql-tag"
import { ResponsiveImageFields } from "@dato/DatoContent/fragments"
import { ProductFields } from "@views/common/graphql"

export const allSeatTypes = gql`
  fragment ResponsiveImageFields on ResponsiveImage {
    srcSet
    src
  }

  query ($skip: IntType!) {
    allSeatTypes(first: "1", orderBy: position_ASC, skip: $skip) {
      id
      title
      sku
      shopifyId
      bracketType {
        id
        slug
        productName
        description
        descriptionFull
        price
        compareAtPrice
        productCategory {
          slug
          name
        }
        proSeriesCategory {
          name
        }
        productSubcategory {
          name
        }
        make {
          name
        }
        model {
          name
        }
        year
        thumbnail {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        images {
          responsiveImage(imgixParams: { fm: png }) {
            ...ResponsiveImageFields
          }
        }
      }
      bracketFilter {
        filters {
          label
          options {
            optionValue
            optionType {
              name
            }
          }
          overridable
        }
      }
      width
      height
      xPos
      yPos
      image {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
      icon {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
      category {
        name
      }
      colorOptions {
        image {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        auxiliaryImages {
          images {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
          styles {
            id
          }
        }
        option {
          id
          title
          material
          colorGroup
          icon {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
          sku
          displaySku
          premium
        }
        override
        sku
      }
      styles {
        id
        sku
        image {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        baseVariantId
        premiumVariantId
        defaultPrice
        premiumPrice
        doorPanelStyle {
          id
        }
        auxiliaryImages {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        style {
          id
          title
          icon {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
        }
      }
    }

    allSeatOptionTypes(orderBy: order_ASC) {
      id
      title
      icon {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
    }
  }
`

export const allPanelTypes = gql`
  fragment ResponsiveImageFields on ResponsiveImage {
    srcSet
    src
  }

  query ($skip: IntType!) {
    allPanelTypes(first: "1", orderBy: position_ASC, skip: $skip) {
      id
      title
      sku
      shopifyId
      width
      height
      xPos
      yPos
      image {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
      icon {
        responsiveImage {
          ...ResponsiveImageFields
        }
      }
      category {
        name
      }
      colorOptions {
        image {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        auxiliaryImages {
          images {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
          styles {
            id
          }
        }
        option {
          id
          title
          material
          colorGroup
          icon {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
          sku
          displaySku
          premium
        }
        override
        sku
      }
      styles {
        id
        sku
        image {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        baseVariantId
        premiumVariantId
        defaultPrice
        premiumPrice
        auxiliaryImages {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        style {
          id
          title
          icon {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
        }
      }
    }
  }
`

export const allTypeStyles = gql`
  fragment ResponsiveImageFields on ResponsiveImage {
    srcSet
    src
  }

  query ($typeId: ItemId!) {
    seatType(filter: { id: { eq: $typeId } }) {
      styles {
        id
        sku
        image {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        style {
          title
          icon {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
          optionTypes {
            icon {
              responsiveImage {
                ...ResponsiveImageFields
              }
            }
            title
            options {
              title
              material
              sku
              displaySku
              premium
              icon {
                responsiveImage {
                  ...ResponsiveImageFields
                }
              }
            }
          }
        }
      }
    }
  }
`

export const allOptionTypes = gql`
  ${ResponsiveImageFields}

  query {
    allSeatOptionTypes {
      id
      options {
        id
        title
        icon {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
      }
    }
  }
`

export const selectStyleQuery = gql`
  ${ProductFields}

  query ($categoryId: ItemId!, $subcategoryId: ItemId!, $styleId: ItemId!) {
    allProducts(
      first: 1
      orderBy: updatedAt_DESC
      filter: {
        hideInCollections: { eq: false }
        proSeries: { eq: true }
        proSeriesCategory: { eq: $categoryId }
        proSeriesSubcategory: { eq: $subcategoryId }
        productStyle: { eq: $styleId }
        make: { exists: false }
        model: { exists: false }
      }
    ) {
      ...ProductFields
    }
  }
`

export const allStyleOptionTypes = gql`
  fragment ResponsiveImageFields on ResponsiveImage {
    srcSet
    src
  }

  query ($id: ItemId!) {
    seatStyle(filter: { id: { eq: $id } }) {
      optionTypes {
        id
        icon {
          responsiveImage {
            ...ResponsiveImageFields
          }
        }
        title
        options {
          id
          title
          material
          colorGroup
          sku
          displaySku
          premium
          icon {
            responsiveImage {
              ...ResponsiveImageFields
            }
          }
          optionImages {
            id
            styles {
              id
            }
            seatOptionType {
              id
              title
            }
            types {
              ... on PanelTypeRecord {
                id
              }
              ... on SeatTypeRecord {
                id
              }
            }
            images {
              responsiveImage {
                ...ResponsiveImageFields
              }
            }
          }
        }
      }
    }
  }
`
